import {
  AfterViewInit,
  Component, ElementRef, inject,
  Injector, OnInit,
  Optional, ViewChild
} from '@angular/core';
import {CommonModule} from "@angular/common";
import { runtimeEventManager } from "@wm/core";

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE
} from "@wm/components-base";
import {getSessionStorageItem, getClonedObject, createArrayFrom, ScriptLoaderService} from "@wm/core";
import {capitalize, each, extend, includes, set} from "lodash-es";


const DEFAULT_CLS = 'app-calendar';
const defaultHeaderOptions = {
  start: 'prev next today',
  center: 'title',
  end: ' dayGridMonth dayGridWeek dayGridDay'
};
const VIEW_TYPES = {
  BASIC: 'basic',
  AGENDA: 'agenda',
  LIST: 'list'
};
const BUTTON_TEXT = {
  YEAR: 'Year',
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day',
  TODAY: 'Today'
};
const SELECTION_MODES = {
  NONE: 'none',
  SINGLE: 'single',
  MULTIPLE: 'multiple'
};
const NEXT_DAY_THRESHOLD = {
  START: '00:00',
  END: '24:00'
};
const CONTROL_OPTIONS = {
  'LIST': 'navigation, today, year, month, week, day',
  'OTHERS': 'navigation, today, month, week, day'
};
// const getUTCDateTime = (dateObj:any) => {
//   dateObj = moment(dateObj);
//   const year = dateObj.format('YYYY'),
//     // javascript starts the month count from '0' where as moment returns the human count
//     month = dateObj.format('MM') - 1,
//     day = dateObj.format('DD'),
//     hours = dateObj.format('HH'),
//     minutes = dateObj.format('mm'),
//     seconds = dateObj.format('ss');
//   return new Date(year, month, day, hours, minutes, seconds);
// };
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-calendar',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmCalendar]',
  template: `<div #calendar [attr.aria-label]="view || 'month'"></div>`,
  providers: [
    provideAsWidgetRef(CalendarComponent)
  ],
  exportAs: 'wmCalendar',
  standalone: true,
  imports: [ CommonModule ],
  styleUrls: ['../../../../../../node_modules/fullcalendar/main.css']
})
export class CalendarComponent extends StylableComponent implements OnInit ,AfterViewInit{
  static initializeProps = register('wm-calendar');
  @ViewChild('calendar') _calendar: ElementRef;
  @ViewChild('datepicker') _datepicker: ElementRef;
  public view: string;
  private eventSources: Array<any> = [];
  public dataset: any;
  public calendartype:any;
  public controls = 'navigation, today, year, month, week, day';
  public datavalue:any;
  public eventtitle:any;
  public eventstart:any;
  public eventend:any;
  public eventallday:any;
  public eventclass:any;
  private $fullCalendar:any;
  private dataSetEvents = {
    events: []
  };
  private changesStack:any[] = [];
  private calendarOptions: any = {
    calendar: {
      height: 600,
      eventSources: this.eventSources,
      editable: true,
      locale: getSessionStorageItem('selectedLocale') || 'en',
      selectable: false,
      headerToolbar: defaultHeaderOptions,
      nextDayThreshold: NEXT_DAY_THRESHOLD,

      }
  };
  scriptLoaderService=  inject(ScriptLoaderService);
  private isNativeMobileApplicationType: boolean;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {

    super(inj, WIDGET_CONFIG, viewParent);
    this.eventSources.push(this.dataSetEvents);
    const projectService = runtimeEventManager.getService('projectService');
    this.isNativeMobileApplicationType =  projectService.isNativeMobileApplicationType();
  }


  override ngOnInit() {
    super.ngOnInit();
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER, ['height']);
    this.setButtonText();
    if(this.isNativeMobileApplicationType) {
      this.calendarOptions.calendar.headerToolbar =
      {
        start: 'prev',
        center: 'title',
        end: 'next'
      }
      this.calendarOptions.calendar.showNonCurrentDates = false;
      this.calendarOptions.calendar.height = 'auto';
    }
  }
  override onStyleChange(key:any, nv:any, ov?:any) {
    super.onStyleChange(key, nv, ov);
    if (key === 'height') {
      this.calendarOptions.calendar.height = this.calculateHeight(nv);
      this.updateCalendarOptions('option', 'height', this.calendarOptions.calendar.height);
    }
  }

  private setButtonText(){
    let { YEAR: buttonTextYear, MONTH: buttonTextMonth, WEEK: buttonTextWeek, DAY: buttonTextDay, TODAY: buttonTextToday } = BUTTON_TEXT;
    this.calendarOptions.calendar.buttonText = {
      year: buttonTextYear,
      month: buttonTextMonth,
      week: buttonTextWeek,
      day: buttonTextDay,
      today: buttonTextToday,
      listYear: buttonTextYear,
      listMonth: buttonTextMonth,
      listWeek: buttonTextWeek,
      listDay: buttonTextDay
    };
  }

  private calculateHeight(height:number): number {
    const $parent = $(this.nativeElement).parent(),
      elHeight:number|any = height || '650px';

    let parentHeight:string|any = $parent.css('height'),
      computedHeight: number;

    if (includes(elHeight, '%')) {
      if (includes(parentHeight, '%')) {
        parentHeight = $parent.height();
      }
      computedHeight = (parseInt(parentHeight, 10) * Number(elHeight.replace(/\%/g, ''))) / 100;
    } else {
      computedHeight = parseInt(elHeight, 10);
    }
    set(this.calendarOptions, 'calendar.views.month.eventLimit', parseInt('' + computedHeight / 200, 10) + 1);
    return computedHeight;
  }
  updateCalendarOptions(operationType: string, argumentKey?: any, argumentValue?: any): void {//
    if (!this.$fullCalendar) {
      this.changesStack.push({
        operationType: operationType,
        argumentKey: argumentKey,
        argumentValue: argumentValue
      });
      return;
    }
    this.applyCalendarOptions(operationType, argumentKey, argumentValue);
  }


 override async ngAfterViewInit() {
   const calendarBundle: any = await this.scriptLoaderService.loadLazyScript('calendar-bundle');
   if(!calendarBundle.loaded) {
     console.error("Error loading calendar-bundle", calendarBundle.error);
     return;
   }

    const calendarEl = this._calendar.nativeElement;
    const FullCalendar = (window as { [key: string]: any })['FullCalendar'];
    const calendar = new FullCalendar.Calendar(calendarEl, this.calendarOptions.calendar);
    this.$fullCalendar =  calendar;
    // this.invokeEventCallback('beforerender', {'$event' : {}});
    calendar.render();
    if (this.changesStack.length) {
      this.changesStack.forEach((changeObj:any) => {
        this.applyCalendarOptions(changeObj.operationType, changeObj.argumentKey, changeObj.argumentValue);
      });
      this.changesStack.length = 0;
    }
    setTimeout(() => {
      this.$fullCalendar.changeView(this.getViewType(this.view ? this.view : 'dayGridMonth'));
    },50);
  }
  applyCalendarOptions(operationType: string, argumentKey?: any, argumentValue?: any): void {
    switch (operationType) {
      case 'render':
        this.$fullCalendar.render();
        break;
      case 'option':
        this.$fullCalendar.setOption(argumentKey, argumentValue);
        break;
      case 'changeView':
        const view = this.getViewType(argumentKey);
        this.$fullCalendar.changeView(view);
        break;
    }
  }


  getViewType(viewKey:any) {
    const calendarType = this.calendartype;
    const view = this.view;
    let result;

    if (view === 'month') {
      result = (calendarType === VIEW_TYPES.LIST) ? 'listMonth' : 'dayGridMonth';
    } else if (view === 'week') {
      result = (calendarType === VIEW_TYPES.BASIC) ?  'dayGridWeek' : (calendarType === VIEW_TYPES.LIST) ? 'listWeek' : 'timeGridWeek';
    } else if (view === 'day') {
      result = (calendarType === VIEW_TYPES.BASIC) ?  'dayGridDay' : (calendarType === VIEW_TYPES.LIST) ? 'listDay' : 'timeGridDay';
    } else if (view === 'year') {
      result = (calendarType === VIEW_TYPES.LIST) ? 'listYear' : '';
    } else {
      result = viewKey;
    }
    return result;
  }
  protected override onPropertyChange(this:any,key: string, nv: any, ov?: any) {
    super.onPropertyChange(key, nv, ov);
    switch (key) {
      case 'selectionmode':
        if (nv !== SELECTION_MODES.NONE) {
          this.calendarOptions.calendar.selectable = true;
          this.updateCalendarOptions('option', 'selectable', true);
          if (nv === SELECTION_MODES.SINGLE) {
            this.calendarOptions.calendar.selectConstraint = {
              startTime: '00:00',
              endTime: '24:00'
            };
            this.updateCalendarOptions('option', 'selectConstraint', this.calendarOptions.calendar.selectConstraint);
          } else {
            this.updateCalendarOptions('option', 'selectConstraint', {});
          }
        } else {
          this.calendarOptions.calendar.selectable = false;
          this.updateCalendarOptions('option', 'selectable', false);
        }
        break;
      case 'view':
        if (nv !== 'month' || this.calendartype === VIEW_TYPES.LIST) {
          this.calendarOptions.calendar.defaultView = this.calendartype + capitalize(nv);
        } else {
          this.calendarOptions.calendar.defaultView = nv;
        }
        this.updateCalendarOptions('changeView', this.calendarOptions.calendar.defaultView);
        break;
      case 'controls':
        this.updateCalendarHeaderOptions(key,nv);
       break;
      case 'dataset':
        let dataSet:any;
        const self = this;
        this.dataset = nv;
        dataSet = createArrayFrom(getClonedObject(nv));
        dataSet = this.constructCalendarDataset(dataSet);
        this.dataSetEvents.events =  dataSet?.filter((event:any)=> {
          event.start = event.start || event.end;
          if (event.start) {
            return true
          }
        return false
        });

        this.renderEventDataSet();
        break;
      case 'show':
        this.$fullCalendar?.changeView(this.getViewType(this.view ? this.view : 'dayGridMonth'));
        break;
      case 'calendartype':
        this.calendartype = nv || 'dayGrid';
        this.updateCalendarHeaderOptions( key, nv);

    }

  }

  /**
   * Returns the data-type for properties in the widget.
   * Pushes the meta data against these types in $rs.dataTypes, as $rs.dataTypes will be referred for the data-types returned.
   * @param prop
   * @returns {*}
   */
  getPropertyType(prop: any,types: any) {
    let type;
    switch (prop) {
      case 'selecteddates':
      case 'currentview':
        type = this.widgetType + '_' + prop;
        types[type] = {
          'fields': {
            'start': {
              'type': 'date, datetime, number, string'
            },
            'end': {
              'type': 'date, datetime, number, string'
            }
          }
        };
        break;
    }
    return type;
  }

  private updateCalendarHeaderOptions(this:any, key:string, nv:string) {
    if(this.isNativeMobileApplicationType) {
      return;
    }
    var ctrls = this.controls, viewType = this.calendartype, left = '', right = '',
      regEx = new RegExp('\\bday\\b', 'g'),
      wp = this.widgetProps,
      viewOptionIndex;

    if (ctrls && viewType) {
      if (includes(ctrls, 'navigation')) {
        left += ' prev next';
      }

      if (includes(ctrls, 'today')) {
        left += ' today';
      }

      if (includes(ctrls, 'year')) {
        right += (viewType === VIEW_TYPES.LIST) ? 'listYear' : '';
      }

      if (includes(ctrls, 'month')) {
        right += (viewType === VIEW_TYPES.LIST) ? ' listMonth' : ' dayGridMonth';
      }

      if (includes(ctrls, 'week')) {
        right += (viewType === VIEW_TYPES.BASIC) ?  ' dayGridWeek' : (viewType === VIEW_TYPES.LIST) ? ' listWeek' : ' timeGridWeek';
      }

      if (regEx.test(ctrls)) {
        right += (viewType === VIEW_TYPES.BASIC) ?  ' dayGridDay' : (viewType === VIEW_TYPES.LIST) ? ' listDay' : ' timeGridDay';
      }
      if (left.charAt(0) === ' ') {
        left = left.substring(1);
      }
      if (right.charAt(0) === ' ') {
        right = right.substring(1);
      }
      extend(this.calendarOptions.calendar.headerToolbar, {'start': left, 'end': right});
    }
    if (key === 'calendartype' && this.$attrs.get('widgetid')) { //if the calendar type is changed then populate the list option in the view

      viewOptionIndex = wp.view.options.indexOf('year');
      if (nv === VIEW_TYPES.LIST && viewOptionIndex == -1) {
        wp.view.options.push('year');
        wp.controls.options = CONTROL_OPTIONS.LIST;
      } else if (nv !== VIEW_TYPES.LIST) {
        wp.controls.options = CONTROL_OPTIONS.OTHERS;
        if (viewOptionIndex > -1) {
          wp.view.options.splice(viewOptionIndex, 1);
        }
        if (this.view === 'year') {

        }
      }
    }
    this.updateCalendarOptions('option', 'selectable', false);
  }
  private constructCalendarDataset(eventSource:any) {
    const properties = {
      title: this.eventtitle || 'title',
      allDay: this.eventallday || 'allday',
      start: this.eventstart || 'start',
      end: this.eventend || 'end',
      className: this.eventclass || 'className'
    };

  }
    renderEventDataSet() {
      const self = this;
      this.$fullCalendar?.batchRendering(function() {
        const events = self.$fullCalendar.getEvents();
        each( events, function( event) {
          const eventData = self.$fullCalendar.getEventById(event.id);
          eventData.remove();
        });
        each( self.dataSetEvents.events, function( event) {
          self.$fullCalendar.addEvent(event);
        });
      });
    }
  // public _datepickerInnerComponent: DatePickerInnerComponent;

}
